import { inject, Injectable } from '@angular/core';
import { AuthService, NewsActionConfigService } from 'gung-standard';
import { first, filter } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CarLinerNewsActionConfigService extends NewsActionConfigService {
  protected authService = inject(AuthService);

  openUserNewsInModal(): void {
    const domainGroupMap = new Map<string, string>([
      ['car-o-liner.se', '12COL'],
      ['car-o-liner.com.sg', '43COL'],
      ['josam.se', '12JOSAM'],
      ['blackhawkcollision.com', '12BLACKHAWK']
    ]);

    const currentHostname = window.location.hostname.toLowerCase();
    const baseDomain = currentHostname.replace(/^sales-test\./, '').replace(/^sales\./, '');
    const requiredGroup = domainGroupMap.get(baseDomain);

    this.authService.getUserActiveGroups().subscribe(groupMap => {
      if (groupMap[requiredGroup] === true) {
        this.getIsEnabledShowUserNewsInModal()
          .pipe(first())
          .subscribe(isEnabled => {
            if (isEnabled) {
              this.newsService
                .getShowInModalUserNews()
                .pipe(
                  filter(news => !!news),
                  first()
                )
                .subscribe(news => {
                  // only open the news modal
                  // in case there is any news to show
                  if (news?.length > 0 && !this.hasModalOpened()) {
                    this.gungModalService.openShowNewsModal(news);
                    sessionStorage.setItem('isNewsModalOpened', 'y');
                  }
                });
            }
          });
      }
    });
  }
}
